var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.781 10.7226L9.45824 8.39906C11.1962 6.07667 10.7223 2.78517 8.39977 1.04731C6.07718 -0.690552 2.7854 -0.216694 1.0474 2.1057C-0.69061 4.42808 -0.216712 7.71959 2.10587 9.45745C3.97156 10.8534 6.53405 10.8534 8.39977 9.45745L10.7235 11.781C11.0155 12.073 11.489 12.073 11.781 11.781C12.073 11.489 12.073 11.0156 11.781 10.7236L11.781 10.7226ZM5.27218 9.00898C3.20798 9.00898 1.53463 7.33577 1.53463 5.27174C1.53463 3.20771 3.20798 1.5345 5.27218 1.5345C7.33638 1.5345 9.00973 3.20771 9.00973 5.27174C9.00754 7.33484 7.33547 9.00678 5.27218 9.00898Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconGray);
export default __webpack_public_path__ + "static/media/SearchIconGray.10f2af144a374eb56f595713dce725bd.svg";
export { ForwardRef as ReactComponent };